import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { ISocketState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const socketModule: Module<ISocketState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default socketModule
